import { X } from "lucide-react";

import { Button } from "@/components/ui/button";
import { ImagePreview } from "@/components/ui/image-preview";
import { useConversationSession } from "@/hooks/use-conversation-session";

export function ComposerAttachments({ personId }: { personId: number }) {
	const { session, draft } = useConversationSession(personId);

	if (draft.images.length === 0) {
		return null;
	}

	return (
		<div className="flex max-h-40 gap-2 overflow-x-auto px-3 pt-3">
			{draft.images.map((image) => (
				<div key={image.id} className="relative shrink-0">
					<ImagePreview src={image.url} alt={image.file.name} className="size-24" />
					<Button
						size="icon"
						variant="secondary"
						aria-label={`Remover ${image.file.name}`}
						disabled={draft.sending}
						onClick={() => session.removeImage(image.id)}
						className="absolute right-1 top-1 size-6 md:size-6"
					>
						<X />
					</Button>
				</div>
			))}
		</div>
	);
}
